module.exports = __webpack_public_path__ + "static/media/tanka.16718ed6.mp3";